import React, { useState } from 'react';
import "../../iqac.css"
import TopNav from '../../../../../Components/TopNav';
import Navbar from '../../../../../Components/Navbar';
import DropdownNav from '../../../../../Components/DropdownNav';
import Footer from '../../../../../Components/Footer';
import Example from '../../../../../Components/Example';
import ScrollToTop from 'react-scroll-to-top';

const RoleOfHonour = () => {
  return (
    <div>
      <Example />
      <ScrollToTop smooth top="1000" />
      <div className='navbar-area'>
        <div className='role-image'>
          <div className='image-cover'>

          </div>
        </div>
  
      </div>

      {/* This iqac details part */}

      <div className='iqac-details'>
        <div className='iqac-header'>
          <h1>Internal Quality Assurance Cell - (IQAC)</h1>
          <h1 className='iqac-obj-tit'>Role Of Honour</h1>
        </div>
      </div>


      <div style={{marginTop:'50px'}}>

      </div>

      <table>
        <tr>
          <th>
            S. No</th>
          <th>	Name</th>
          <th>Year</th>
        </tr>
        <tr>
          <td>1</td>
          <td>Arabic</td>
          <td>
          2001 -2006</td>
        </tr>
        <tr>
          <td>2</td>
          <td>	Dr. H.S. Sheik Ibrahim</td>
          <td>	2006 – 2012</td>
        </tr>
        <tr>
          <td>3</td>
          <td>	Prof. A.Abdul Rasheed</td>
          <td>2012 -2013</td>
        </tr>
        <tr>
          <td>4</td>
          <td>Dr. M. Asrar Sheriff</td>
          <td>2013 – 2015</td>
        </tr>
        <tr>
          <td>5</td>
          <td>Dr. Fayaz Mohammed Bijli</td>
          <td>2015 – 2017</td>
        </tr>
        <tr>
          <td>6</td>
          <td>Mr. S. Kamaluddin</td>
          <td>2017</td>
        </tr>
        <tr>
          <td>7</td>
          <td>Mr. S.A. Sheik Mohamed</td>
          <td>2017-2020</td>
        </tr>
      </table>

      <Footer />
    </div>
  );
}

export default RoleOfHonour;
